import React from "react";

export const ArrowUpward = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="arrow_upward">
<path id="Vector" d="M3.12924 5.52929L3.05853 5.6L3.12924 5.67071L3.97524 6.51671L4.04589 6.58736L4.1166 6.51677L7.29995 3.33912V10.4V10.5H7.39995H8.59995H8.69995V10.4V3.33973L11.8772 6.52265L11.9479 6.59348L12.0187 6.52271L12.8707 5.67071L12.9414 5.6L12.8707 5.52929L8.07066 0.729289L7.99995 0.658578L7.92924 0.729289L3.12924 5.52929Z" fill="#0056D6" stroke="#0056D6" strokeWidth="0.2"/>
<path id="Rectangle 345" d="M2.3999 10.4V12C2.3999 12.8837 3.11625 13.6 3.9999 13.6H11.9999C12.8836 13.6 13.5999 12.8837 13.5999 12V10.4" stroke="#0061E0" strokeWidth="1.6"/>
</g>
</svg>

  );
};
